import { QueryClient } from '@tanstack/react-query';

// retrieve dehydrated react-query state to hydrate
const FIVE_MINUTES = 5 * 60 * 1000;
const DEFAULT_QUERYCLIENT_OPTIONS = {
    defaultOptions: {
        queries: {
            retry: false,
            refetchOnWindowFocus: false,
            refetchOnReconnect: false,
            refetchOnMount: false,
            staleTime: FIVE_MINUTES,
        },
    },
};

export const queryClient = new QueryClient(DEFAULT_QUERYCLIENT_OPTIONS);
